import React, { useEffect, useState } from "react";
import { useLang } from "../context/LangContext";
import { api } from "../lib/api";
import SimpleMarkdown from "../components/SimpleMarkdown";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  const { t, lang } = useLang();
  const [content, setContent] = useState("");
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/legal")
      .then((r) => setContent(lang === "en" ? r.data.datenschutz_en || "" : r.data.datenschutz_de || ""))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [lang]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="datenschutz-page">
      <button onClick={() => navigate(-1)} className="flex items-center text-sm text-muted-foreground hover:text-foreground mb-4 transition-colors">
        <ArrowLeft className="w-4 h-4 mr-1" /> {lang === "en" ? "Back" : "Zurück"}
      </button>
      <p className="label-mini">Legal</p>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight leading-none mt-1 mb-6">{t("legal.privacyTitle")}</h1>
      <div className="swiss-card p-6 text-sm space-y-4 text-foreground/90">
        {loaded && content && content.trim() ? (
          <SimpleMarkdown text={content} />
        ) : (
          <>
            <p className="text-muted-foreground italic">{t("legal.placeholder")}</p>
            <div>
              <h3 className="font-semibold mb-1">1. Verantwortlicher</h3>
              <p>Beta-Webagentur, Düsseldorf, Deutschland</p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">2. Cookies</h3>
              <p>Diese Anwendung verwendet ausschließlich technisch notwendige Session-Cookies, um Ihre Anmeldung aufrechtzuerhalten. Es werden keine Tracking- oder Marketing-Cookies eingesetzt.</p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">3. Daten</h3>
              <p>Wir speichern ausschließlich die für den Betrieb der Retourenverwaltung erforderlichen Daten (Bestellnummern, Kundennamen, Retouren-Details, Fotos).</p>
            </div>
            <div>
              <h3 className="font-semibold mb-1">4. Sitzungsdauer</h3>
              <p>Nach 20 Minuten Inaktivität werden Sie automatisch abgemeldet.</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
